/**
 * return type --> false -> Let go to Group ,
 * return type --> true ->  Dont let go to Group
 */

import { Group } from '../groups.types'

const checkToShowGroupPage = (
  slug: string,
  userGroups: Group[],
  currentGroup: Group
) => {
  let isUserGroup = false

  userGroups.forEach((group) => {
    if (slug === group.slug) {
      isUserGroup = true
    }
  })

  if (isUserGroup) {
    return true
  } else {
    for (let i = 0; i < userGroups.length; i++) {
      if (userGroups[i].bootcamp_type === currentGroup.bootcamp_type)
        return false
    }

    return true
  }
}

export default checkToShowGroupPage
